/** 「属性」タブ。プロファイル(読み取り)とカスタム属性。直すのはヘッダーの「編集」から。 */
import type { IdpUserDetail } from "../../../lib/api";
import { jst } from "../../../lib/format";
import { KeyValueList, Section } from "../../../ui";
import { useIdpCustomAttrs } from "../hooks";

export function AttributesTab({ user }: { user: IdpUserDetail }) {
  const attrs = useIdpCustomAttrs();
  const declared = attrs.data?.items ?? [];
  const p = user.profile;
  return (
    <div className="ui-detail-grid">
      <div className="ui-detail-col">
        <Section title="プロファイル">
          <KeyValueList
            items={[
              { label: "ユーザー名", always: true, value: p.username },
              { label: "表示名", value: user.displayName },
              { label: "姓", value: p.lastName },
              { label: "名", value: p.firstName },
              { label: "メールアドレス", value: p.email },
              { label: "メール確認済み", always: true, value: p.emailVerified ? "はい" : "いいえ" },
              { label: "作成日時", value: jst(p.createdAt) },
            ]}
          />
        </Section>
      </div>
      <div className="ui-detail-col">
        <Section title="カスタム属性">
          {declared.length === 0 ? (
            <div style={{ color: "var(--ux-text-tertiary)" }}>
              カスタム属性は宣言されていない(「カスタム属性」画面で足す)。
            </div>
          ) : (
            <KeyValueList
              items={declared.map((a) => ({
                label: a.displayName || a.name,
                value: p.attributes[a.name],
              }))}
            />
          )}
        </Section>
      </div>
    </div>
  );
}
